var render, staticRenderFns
import script from "./estimatedcost-picture.vue?vue&type=script&lang=js"
export * from "./estimatedcost-picture.vue?vue&type=script&lang=js"
import style0 from "./estimatedcost-picture.vue?vue&type=style&index=0&id=18f78934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports